import { memo, type MouseEvent, type ReactElement } from 'react';
import type { TimelineBlock } from '../../../domain/scheduling/scheduleMath';
import { minuteToPercent } from './timelineUtils';

interface ScheduleBlockProps {
  block: TimelineBlock;
  selected: boolean;
  onSelect: (block: TimelineBlock) => void;
}

const KIND_CLASS: Record<TimelineBlock['kind'], string> = {
  FLIGHT: 'fsg-block-flight',
  TURNAROUND: 'fsg-block-turn',
  MAINTENANCE: 'fsg-block-maint',
  CONFLICT: 'fsg-block-conflict',
};

function ScheduleBlockImpl({ block, selected, onSelect }: ScheduleBlockProps): ReactElement {
  const classes = ['fsg-block', KIND_CLASS[block.kind]];
  if (selected) classes.push('is-selected');
  if (block.continuesFromPrevious) classes.push('is-cont-left');
  if (block.continuesToNext) classes.push('is-cont-right');

  const handleClick = (event: MouseEvent<HTMLButtonElement>): void => {
    // Keep the lane's "add flight" click from firing underneath the block.
    event.stopPropagation();
    onSelect(block);
  };

  return (
    <button
      type="button"
      className={classes.join(' ')}
      style={{
        left: `${minuteToPercent(block.startMinute)}%`,
        width: `${minuteToPercent(block.endMinute - block.startMinute)}%`,
      }}
      title={`${block.label} · ${block.detail}`}
      aria-pressed={selected}
      onClick={handleClick}
    >
      <span className="fsg-block-label">{block.label}</span>
    </button>
  );
}

export const ScheduleBlock = memo(ScheduleBlockImpl);
